import { Api } from "./api"
import { GetContextTypesResult } from "./api.types"
import { getGeneralApiProblem } from "./api-problem"

export class ContextTypeApi {
  private api: Api

  constructor(api: Api) {
    this.api = api
  }
  
  async getAll() : Promise<GetContextTypesResult> {
    try {
      const response = await this.api.getContextTypes()

      if (!response.ok) {
        const problem = getGeneralApiProblem(response)
        if (problem) return problem
      }

      const payload = response.data

      return { kind: 'ok', payload }
    } catch (e) {
      return { kind: "bad-data" }
    }
  }
}
